import { Card, Layout, TextContainer } from "@shopify/polaris";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import "../../css/indicator.css";
import { actFetchFilter } from "../../actions/index";
import config from "../../config/config";
import { useHistory } from "react-router-dom";

function IndicatorFilter() {
  const dispatch = useDispatch();
  const {
    order_paid_paypal,
    order_paypal_synced,
    order_paypal_err,
    order_stripe,
    order_stripe_synced,
    order_stripe_err,
  } = useSelector((state) => state.dataStatistical);
  const dataSettings = useSelector((state) => state.dataSettings);
  const history = useHistory();
  const configFilters = [
    {
      title: "PayPal orders",
      data: [order_paid_paypal, order_paypal_synced, order_paypal_err],
    },
    {
      title: "Stripe orders",
      data: [order_stripe, order_stripe_synced, order_stripe_err],
    },
  ];
  const filters = ["Fullfilled Orders", "Synced Orders", "Sync Error"];

  const getStatus = (value) => {
    switch (value) {
      case "Fullfilled Orders":
        return "all";
      case "Synced Orders":
        return "1";
      case "Sync Error":
        return "total_err";
      default:
        return "all";
    }
  };

  const handleIndicatorFilter = (value, filter) => {
    let path = config.pathName + "/orders?" + config.urlParamsValue;
    let payload = { type: "filter" };
    switch (value.title) {
      case "PayPal orders":
        payload.payment = "paypal";
        payload.status = getStatus(filter);
        break;
      case "Stripe orders":
        payload.payment = "stripe";
        payload.status = getStatus(filter);
        break;
      default:
        payload.payment = "paypal";
        payload.status = "all";
        break;
    }
    dispatch(actFetchFilter(payload));
    history.push(path);
  };
  return (
    <div className="mt-3 mb-3">
      <Row className="indicator-filter-row">
        {configFilters.map((type, index) => (
          <Col className="mt-2" xs="12" sm="12" xl="6" key={index}>
            <Card title={type.title}>
              <Card.Section>
                <Row>
                  {type.data.map((value, index) => (
                    <Col xs="12" sm="12" md="4" className="mt-2" key={index}>
                      <Card sectioned>
                        <div className="indicator-filter-card">
                          <TextContainer>
                            <b
                              className="indicator-filter-card-title"
                              onClick={() =>
                                handleIndicatorFilter(type, filters[index])
                              }
                            >
                              {filters[index]}
                            </b>
                            <p className="indicator-filter-card-value">
                              {value}
                            </p>
                          </TextContainer>
                        </div>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Card.Section>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default IndicatorFilter;
